<div class="card-shadow container-fluid">
    <div *ngFor="let product of products">
        <products-productitem class="row card-shadow2 border" [product]="product"
            style="margin-bottom: 10px; cursor: pointer;" (click)="cardClicked(product.pid)">
        </products-productitem>
    </div>
</div>